import Vue from 'vue'
import PhotoGrid from 'vue-photo-grid'

Vue.use(PhotoGrid)
